import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Form, Spinner, FormControl, Row, Col } from "react-bootstrap";
import { useLazyQuery, useMutation } from '@apollo/client';
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from '../../../const';
import { ReactIcons } from '../../../icons';
import { CREATE_PROMOTION, UPDATE_PROMOTION } from '../../../apollo/shop/mutation';
import { covertTimeZone } from '../../../helper';
// import UploadMuitpleImage from '../../../components/UploadMutipleImage';
import { GET_PRESIGN_URL } from '../../../apollo/presignUrl/query';
// import { uploadFileToS3 } from '../../../helper/UploadImgToS3';

const FormPromotion = ({ data, editMode, onClose }) => {
    const [discountType, setDiscountType] = useState(data?.discountType ?? false)
    const [fileList, setFileList] = useState([]);


    // apollo client hooks
    const [createPromotion, { loading: loadingCreatePromotion }] = useMutation(CREATE_PROMOTION);
    const [updatePromotion, { loading: loadingUpdatePromotion }] = useMutation(UPDATE_PROMOTION);
    const [getPresignUrl] = useLazyQuery(GET_PRESIGN_URL);
    // validation schema
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('ປ້ອນຊື່ຫົວຂໍ້ກ່ອນ!'),
        discount: Yup.number().required('ປ້ອນສ່ວນຫລຸດກ່ອນ!').positive('ສ່ວນຫຼຸດຕ້ອງເປັນບວກ'),
    });

    // create promotion
    const handleCreate = async (values) => {
        if (loadingCreatePromotion) return;
        const userData = localStorage.getItem("SHOP_DATA");
        if (!userData) return;
        const locals = JSON.parse(userData);

        // const uploadedFiles = [];
        // for (const file of fileList) {
        //     try {
        //         const resFile = await uploadFileToS3(file, getPresignUrl);
        //         console.log("Uploaded file:", resFile);
        //         uploadedFiles.push(resFile); // Store the uploaded file details
        //     } catch (error) {
        //         console.error("Error uploading file:", error);
        //         return; // Stop execution if an error occurs
        //     }
        // }

        // console.log("All uploaded files:", uploadedFiles);


        try {
            const res = await createPromotion({
                variables: {
                    data: {
                        ...values,
                        shop: locals?.id,
                        discountType: discountType
                    }
                }
            });
            if (res) {
                onClose();
            }
        } catch (error) {
            console.error(error);
        }
    };

    // update promotion
    const handleUpdate = async (values) => {
        if (loadingUpdatePromotion) return;
        const userData = localStorage.getItem("SHOP_DATA");
        if (!userData) return;
        const locals = JSON.parse(userData);
        try {
            const res = await updatePromotion({
                variables: {
                    where: {
                        id: data?.id
                    },
                    data: {
                        ...values,
                        discountType: discountType,
                        shop: locals?.id
                    },
                }
            });
            if (res) {
                onClose();
            }
        } catch (error) {
            console.error(error);
        }
    };

    console.log("fileList: ", fileList)

    return (
        <div className='p-6 w-50'>
            {/* <UploadMuitpleImage fileList={fileList} setFileList={setFileList} />
            <br /> */}
            <Formik
                initialValues={{
                    name: data?.name ?? '',
                    discount: data?.discount ?? 0,
                    status: data?.status ?? "DEACTIVED",
                    startDate: data?.startDate ? new Date(data.startDate) : null,
                    endDate: data?.endDate ? new Date(data.endDate) : null,
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    editMode ? handleUpdate(values) : handleCreate(values);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label>ຫົວຂໍ້ໂປຣໂມຊັ່ນ</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                                isInvalid={touched.name && !!errors.name}
                            />
                            <FormControl.Feedback type="invalid">
                                {errors.name}
                            </FormControl.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="discount">
                            <Form.Label>ສ່ວນຫຼຸດ</Form.Label>
                            <Form.Control
                                type="number"
                                name="discount"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.discount}
                                isInvalid={touched.discount && !!errors.discount}
                            />
                            <FormControl.Feedback type="invalid">
                                {errors.discount}
                            </FormControl.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="discountType">
                            <Form.Label>ປະເພດສ່ວນຫຼຸດ</Form.Label>
                            <div className="d-flex  gap-4">
                                <Form.Check
                                    type="radio"
                                    id="fixedDiscount"
                                    name="discountType"
                                    label="ເປັນຈຳນວນເຕັມ (x,xxx)"
                                    value={true} // Fixed discount type is true
                                    checked={discountType === true} // Check if discountType is true
                                    onChange={(e) => setDiscountType(true)} // Set discountType to true
                                />
                                <Form.Check
                                    type="radio"
                                    id="percentageDiscount"
                                    name="discountType"
                                    label="ເປັນເປີເຊັ່ນ (%)"
                                    value={false} // Percentage discount type is false
                                    checked={discountType === false} // Check if discountType is false
                                    onChange={(e) => setDiscountType(false)} // Set discountType to false
                                />
                            </div>
                        </Form.Group>

                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="startDate">
                                    <Form.Label>ເລິ່ມຕົ້ນ {editMode && covertTimeZone(data?.startDate)}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="startDate"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.startDate}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="endDate">
                                    <Form.Label>ສິ້ນສຸດ  {editMode && covertTimeZone(data?.endDate)}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="endDate"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.endDate}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        {editMode && <Form.Group className="mb-3" controlId="status">
                            <Form.Label>ສະຖານະ</Form.Label>
                            <Form.Select
                                name="status"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.status}
                            >
                                <option value="ACTIVED">ເປີດໃຊ້</option>
                                <option value="DEACTIVED">ປີດນຳໃຊ້</option>
                            </Form.Select>
                            <FormControl.Feedback type="invalid">
                                {errors.status}
                            </FormControl.Feedback>
                        </Form.Group>}

                        <br />


                        <div className="d-flex justify-content-end gap-2">
                            <Button variant="light" onClick={onClose} >
                                ຍົກເລີກ
                            </Button>
                            <Button style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }} type="submit" disabled={loadingCreatePromotion}>
                                {(loadingCreatePromotion) ? <><Spinner size="sm" /> updating</> : <span>
                                    <ReactIcons.FaCheck />  {editMode ? "ແກ້ໄຂ" : "ບັນທຶກ"}
                                </span>}
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default FormPromotion;